<div class="d-flex justify-content-center align-items-center" style="width: 100wh;height: 100vh;">
    <iframe src="./assets/pages/Accreditation Agreement Rev. 5.html" frameborder="0"
        style="width: 100%; height: 100vh;"></iframe>
</div>